import { get, includes, isEmpty, difference, chain } from "lodash"
import { getModelMetadata } from "selectors/modelMetadata"
import { createSelector } from "reselect"

const EMPTY_ARRAY = []
export const getMissingDataFiles = createSelector(
  [getModelMetadata],
  (modelMetadata) => get(modelMetadata, "missingDataFiles", EMPTY_ARRAY),
)

export function getBetaTypes(missingDataFiles) {
  return chain([
    !includes(missingDataFiles, "predictedBeta") && "predicted",
    !includes(missingDataFiles, "historicalBeta") && "historical",
  ])
    .compact()
    .join("\n")
    .value()
}

export function modelSupportsComposites(missingDataFiles) {
  return !includes(missingDataFiles, "composite")
}

export function betasAreMissing(missingDataFiles) {
  return isEmpty(difference(["predictedBeta", "historicalBeta"], missingDataFiles))
}

export function betasSubQuery(missingDataFiles, extraFields = []) {
  const betaTypes = getBetaTypes(missingDataFiles)
  if (betaTypes) {
    return `
        beta{
          ${extraFields.join("\n")}
          ${betaTypes}
        }
        `
  }
  return ""
}

export function betasQueryFragment(missingDataFiles, grouped = false) {
  const betaTypes = getBetaTypes(missingDataFiles)
  if (betaTypes) {
    return `
    ${betaTypes}
    ${!grouped ? `securityBeta {
      ${betaTypes}
    }` : ""}`
  }
  return ""
}
